import styled from 'styled-components';

export default styled.div`
    .iframeContainer {
        padding-top: 20px;
        height: 75vh;
        max-height: 100vh;
    }
`;